import { render } from "./SelectPet.vue?vue&type=template&id=bc52ee40&scoped=true"
import script from "./SelectPet.vue?vue&type=script&lang=js"
export * from "./SelectPet.vue?vue&type=script&lang=js"

import "./SelectPet.vue?vue&type=style&index=0&id=bc52ee40&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/vue-smart-reco-vet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc52ee40"]])

export default __exports__